import React from "react";
import "./../../global/css/component/legacyStyles.scss";

export const goToStepButton = (props) => {
  const {
    goToStep,
    schemaProps: {
      jump_to_step: { buttonPrimary, step },
    },
  } = props;

  const callStep = (step) => {
    goToStep(step);
  };

  const rendergoToStepButton = () => {
    return (
      <>
        <button
          onClick={() => {
            callStep(step);
          }}
          type="button"
          className="usa-button"
        >
          {buttonPrimary}
        </button>
      </>
    );
  };

  return <div>{rendergoToStepButton()}</div>;
};
